import { stringArrayToSelectOptions } from '@/utils/misc.ts'
import { SelectGroupOption, SelectOption } from '@/common/types/components.def.ts'
import { get } from 'lodash-es'

export const Department = {
  Administration: 'Administration',
  BusinessUnitsCountry: 'Business Units - Country',
  CardinalPoint: 'Cardinal Point',
  CapitalStrategy: 'Capital Strategy',
  Compliance: 'Compliance',
  DevelopmentLab: 'Development Lab',
  ESG: 'ESG',
  EnterpriseDataManagement: 'Enterprise Data Management',
  Finance: 'Finance',
  GroundTacticalResearch: 'Ground Tactical Research',
  HumanCapital: 'Human Capital',
  Investment: 'Investment',
  IT: 'IT',
  Legal: 'Legal',
  MiddleOffice: 'Middle Office',
  PolymerAlphaCaptureSystems: 'Polymer Alpha Capture Systems',
  PolymerPlatformStrategy: 'Polymer Platform Strategy',
  ProductsSpecialist: 'Products Specialist',
  QuantInvestment: 'Quant Investment',
  RiskQuantAnalytics: 'Risk & Quant Analytics',
  Sustainability: 'Sustainability',
  TradingExecution: 'Trading & Execution',
}
export const DepartmentOptions = stringArrayToSelectOptions(Object.values(Department))

export const SubDepartment = {
  Investment: 'Investment',
  NonInvestment: 'Non-Investment',
}
export const SubDepartmentOptions = stringArrayToSelectOptions(Object.values(SubDepartment))

export const SubGroup = {
  Investment: 'Investment Team',
  NonInvestment: 'Non-Investment Team',
  Management: 'Management Team',
  Trading: 'Trading Team',
}
export const SubGroupOptions = stringArrayToSelectOptions(Object.values(SubGroup))

export const DepartmentGrouping = {
  Investment: 'Investment',
  InvestmentLongOnly: 'Investment - Long Only',
  InvestmentSupportFund: 'Investment Support - Fund',
  InvestmentSupportManager: 'Investment Support - Manager',
  InvestmentSupportFundAndManager: 'Investment Support - Fund & Manager',
  NonInvestment: 'Non-Investment',
  RiskQuantFundTw: 'R&Q(Fund) - TW',
  RiskQuantManagerAndNonMoManagerTw: 'R&Q(Manager) & Non-MO(Manager) - TW',
  NonRiskQuantManagerAndNonMoTw: 'Non-R&Q(Manager) & Non-MO - TW',
}
export const DepartmentGroupingOptions = stringArrayToSelectOptions(Object.values(DepartmentGrouping))

export const BusinessUnit = {
  Polymer: 'Polymer',
  PAG: 'PAG',
}
export const BusinessUnitOptions = stringArrayToSelectOptions(Object.values(BusinessUnit))

export const Position = {
  Pm: 'PM',
  Apm: 'APM',
  Analyst: 'Analyst',
  Management: 'Management',
  NonInvestment: 'Non-Investment',
  Intern: 'Intern',
  Quant: 'Quant Investment',
  Equinox: 'Equinox',
  NAGDivision: 'NAG Division', // Neo Alpha Group
}
export const PositionOptions = stringArrayToSelectOptions(Object.values(Position))

export const CorporateRank = {
  Analyst: 'Analyst',
  Associate: 'Associate',
  VicePresident: 'Vice President',
  ExecutiveDirector: 'Executive Director',
  Director: 'Director',
  ManagingDirector: 'Managing Director',
  Principal: 'Principal',
  Others: 'Others',
}
export const CorporateRankOptions = stringArrayToSelectOptions(Object.values(CorporateRank))

export const WorkInfoUpdateReason = {
  NewHire: 'New Hire',
  Promotion: 'Promotion',
  TitleChange: 'Title Change',
  CountryTransfer: 'Country Transfer',
  Rehire: 'Rehire',
  OfficeLocationChange: 'Office Location Change',
  DepartmentTransfer: 'Department Transfer',
  ChangeOfReportingManager: 'Change of Reporting Manager',
  ChangeOfDepartmentGrouping: 'Change of Department Grouping',
  UpdateOfCostDistribution: 'Update of Cost Distribution',
  EmploymentEntityChange: 'Employment Entity Change',
  EmploymentTypeConversion: 'Employment Type Conversion',
}
export const WorkInfoUpdateReasonOptions = stringArrayToSelectOptions(Object.values(WorkInfoUpdateReason))

export type OfficeCodeConfig = {
  address: string
  chineseAddress?: string
}

export const OfficeCode: Record<string, OfficeCodeConfig> = {
  'HK-PP3-5F': {
    address: '5F Three Pacific Place, 1 Queen\'s Road East, Hong Kong',
    chineseAddress: '香港皇后大道東1號太古廣場三座5樓',
  },
  'HK-PP3-15F': {
    address: '15F Three Pacific Place, 1 Queen\'s Road East, Hong Kong',
    chineseAddress: '香港皇后大道東1號太古廣場三座15樓',
  },
  'HK-PP3-24F': {
    address: '24F Three Pacific Place, 1 Queen\'s Road East, Hong Kong',
    chineseAddress: '香港皇后大道東1號太古廣場三座24樓',
  },
  'HK-PP3-28F': {
    address: '28F Three Pacific Place, 1 Queen\'s Road East, Hong Kong',
    chineseAddress: '香港皇后大道東1號太古廣場三座28樓',
  },
  'SH-MAT-20F': {
    address: '#2052, Level 20, Mirae Asset Tower, 166 Lujiazui Ring Road, Pudong, Shanghai, 200120, China',
  },
  'SG-AST1-34F': { address: '8 Marina View, #34-04/05, Asia Square Tower 1, Singapore 018960' },
  'AUS-SYD-MP-22F': { address: 'Suite 22.02, Level 22, 60 Martin Place, Sydney, NSW 2000, Australia' },
  'TW-NSP-43F': { address: '43/F-1A, No. 100, Nan Shan Plaza Songren Road, Taipei 110016, Taiwan' },
  'JP-OFCNT-21F': { address: '21/F, Otemachi Financial City North Tower 1-9-5, Otemachi, Chiyoda-ku Tokyo 100-0004, Japan' },
  'US-BOS-BSS-13F': { address: '1309 Beacon Street Suite 300, Brookline, MA, 02446 USA' },
  'US-NY-PA-22F': { address: '320 Park Avenue, 22nd Floor, Suite 2230, New York, NY 10022, USA' },
  'US-NY-TA-26F': { address: '26th Floor, 825 Third Avenue, New York, 10022, USA' },
}

export const Country = {
  Australia: 'Australia',
  HongKong: 'Hong Kong',
  China: 'China',
  Japan: 'Japan',
  Singapore: 'Singapore',
  Taiwan: 'Taiwan',
  UnitedStates: 'United States',
  UnitedKingdom: 'United Kingdom',
  Korea: 'Korea',
  India: 'India',
}
export const CountryOptions = stringArrayToSelectOptions(Object.values(Country))

export const OfficeLocation = {
  [Country.Australia]: {
    Melbourne: ['Default'],
    Sydney: ['AUS-SYD-MP-22F'],
    Perth: ['Default'],
  },
  [Country.China]: { Beijing: ['Default'], Shanghai: ['SH-MAT-20F'] },
  [Country.HongKong]: { 'Hong Kong': ['HK-PP3-5F', 'HK-PP3-15F', 'HK-PP3-24F', 'HK-PP3-28F'] },
  [Country.Japan]: { Tokyo: ['JP-OFCNT-21F'] },
  [Country.Singapore]: { Singapore: ['SG-AST1-34F'] },
  [Country.Taiwan]: { Taipei: ['TW-NSP-43F'] },
  [Country.UnitedStates]: {
    Boston: ['US-BOS-BSS-13F'],
    'New York': ['US-NY-TA-26F', 'US-NY-PA-22F'],
    Nevada: ['Default'],
  },
  [Country.UnitedKingdom]: { London: ['Default'] },
  [Country.Korea]: { Seoul: ['Default'] },
  [Country.India]: { Mumbai: ['Default'] },
} as const

export const cityAddress = (country: string, city: string) => `${city}, ${country}`
export const OfficeLocationCountryOptions = Object.keys(OfficeLocation).map(x => ({ label: x, value: x }))
export const OfficeLocationCityOptions = Object.entries(OfficeLocation).map(([country, cityDict]) => ({
  label: country,
  options: Object.keys(cityDict).map(city => ({ label: city, value: city })),
})) as SelectGroupOption[]
export const NewOfficeLocationBuildingOptions = (city: string): SelectOption[] => get(
  Object.values(OfficeLocation).reduce((acc, curr) => ({ ...acc, ...curr }), {}),
  [city],
)?.map(
  (x: string) => ({ label: x, value: x })) || []

export const OfficeLocationCityOptionsByCountry = (country: string): SelectOption[] => Object.keys(OfficeLocation[country as keyof typeof OfficeLocation] || {}).flat().map(
  x => ({ label: x, value: x }))

export const OfficeLocationBuildingOptions = (country: string, city: string): SelectOption[] => get(
  OfficeLocation,
  [country, city],
)?.map(
  (x: string) => ({ label: x, value: x })) || []

export const OfficeLocationCityAddressOptions = Object.entries(OfficeLocation).map(([country, cityMap]) => Object.keys(
  cityMap).map(
  x => cityAddress(country, x))).flat()

export const CostCenterCode = {
  CLO100: 'CLO100',
  CLOJLOMG50: 'CLOJLOMG50',
  HF100: 'HF100',
  HF50: 'HF50',
  HF666: 'HF666',
  JLO100: 'JLO100',
  MG100: 'MG100',
  TWBRNRQ: 'TWBRNRQ',
  TWRO: 'TWRO',
  TWBRRANDQ: 'TWBRR&Q',
}
export const CostCenterCodeOptions = stringArrayToSelectOptions(Object.values(CostCenterCode))
